// extracted by mini-css-extract-plugin
export default {"ctn":"Contact_ctn__1mQKR","wrapper":"Contact_wrapper__d9uv4","heading":"Contact_heading__d2oOV","header":"Contact_header__Cm+fW","subHeading":"Contact_subHeading__lhBA-"};